import {
  HIDE_DUPLICATES,
  RESET_DUPLICATES_STATE,
  SET_DUPLICATE_CONTACTS,
  SHOW_DUPLICATES,
  START_LOADING
} from '../actions/duplicates';

export default function (state = {}, action) {
  switch (action.type) {
  case HIDE_DUPLICATES:
    return { ...state, viewActive: false };
  case RESET_DUPLICATES_STATE:
    return { ...state, people: [], companies: [] };
  case SET_DUPLICATE_CONTACTS: {
    const { people, companies, groups, meta } = action.payload;
    const newState = { ...state, groups, meta, isLoading: false };

    if (people) newState.people = people;
    if (companies) newState.companies = companies;

    return newState;
  }
  case SHOW_DUPLICATES:
    return { ...state, isLoading: true, viewActive: true };
  case START_LOADING:
    return { ...state, isLoading: true };
  default:
    return state;
  }
}
